import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import HttpClient from "./Services/HttpClient";

// global styles (Vite is fine with this)
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/style.scss";
import "../src/assets/style/width.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./components/Layouts/Layout";
import PrivateRouter from "./components/Layouts/PrivateRouter.js";

// lazy-loaded pages (TOP LEVEL ONLY)
const Login = lazy(() => import("../src/screens/Login/Login.jsx"));
const Registration = lazy(
  () => import("../src/screens/Login/Registration.jsx"),
);
const ResetPassword = lazy(
  () => import("../src/screens/Login/ResetPassword.jsx"),
);
const AdminList = lazy(() => import("../src/screens/AdminList/AdminList.jsx"));
const AddAdmin = lazy(() => import("../src/screens/AdminList/AdminView.jsx"));
const Role = lazy(() => import("../src/screens/Role/Role.jsx"));
const AddRole = lazy(() => import("../src/screens/Role/AddRole.jsx"));
const CategoryList = lazy(() => import("../src/screens/Category/Category.jsx"));
const CategoryAdd = lazy(
  () => import("../src/screens/Category/AddCategory.jsx"),
);
const AttributesList = lazy(
  () => import("../src/screens/Attributes/Attributes.jsx"),
);
const AttributesAdd = lazy(
  () => import("../src/screens/Attributes/AddAttributes.jsx"),
);
const Location = lazy(() => import("../src/screens/Location/Location.jsx"));
const AddLocation = lazy(
  () => import("../src/screens/Location/AddLocation.jsx"),
);
const Dashboard = lazy(() => import("../src/screens/Dashboard/Dashboard.jsx"));
const MaterialList = lazy(() => import("../src/screens/Material/Material.jsx"));
const AddMaterial = lazy(
  () => import("../src/screens/Material/MaterialAdd.jsx"),
);
const WarehouseList = lazy(
  () => import("../src/screens/Warehouse/Warehouse.jsx"),
);
const AddWarehouse = lazy(
  () => import("../src/screens/Warehouse/WarehouseAdd.jsx"),
);
const ProjectList = lazy(() => import("../src/screens/Project/Project.jsx"));
const AddProject = lazy(() => import("../src/screens/Project/ProjectAdd.jsx"));
const Notification = lazy(
  () => import("../src/screens/Notification/Notification.jsx"),
);
const WareHouseMaterialList = lazy(
  () => import("../src/screens/WarehouseManagement/WareHouseMaterialList.jsx"),
);
const WareHouseMaterialAdd = lazy(
  () => import("../src/screens/WarehouseManagement/WareHouseMaterialAdd.jsx"),
);

const ProjectMaterialList = lazy(
  () => import("../src/screens/ProjectManagement/ProjectMaterialList.jsx"),
);
const ProjectMaterialAdd = lazy(
  () => import("../src/screens/ProjectManagement/ProjectMaterialAdd.jsx"),
);

const WareHouseViewProjects = lazy(
  () => import("../src/screens/WarehouseManagement/WareHouseViewProjects.jsx"),
);

const WareHouseReservedMaterial = lazy(
  () =>
    import("../src/screens/WarehouseManagement/WareHouseReservedMaterial.jsx"),
);

const ReservedMaterialList = lazy(
  () => import("../src/screens/ProjectManagement/ReservedMaterialList.jsx"),
);
const ReservedMaterialAdd = lazy(
  () => import("../src/screens/ProjectManagement/ReservedMaterialAdd.jsx"),
);
const ReservedMaterialIssueList = lazy(
  () =>
    import("../src/screens/ProjectManagement/ReservedMaterialIssueList.jsx"),
);
const ReservedMaterialIssueView = lazy(
  () => import("../src/screens/ProjectManagement/ReserMatIssueView.jsx"),
);
const ProjectAccIssueView = lazy(
  () => import("../src/screens/ProjectManagement/ProjectAccIssueView.jsx"),
);
const ProjectWarReqIssueView = lazy(
  () => import("../src/screens/ProjectManagement/ProjectWarReqIssueView.jsx"),
);
const ProjectWarAccIssueView = lazy(
  () => import("../src/screens/ProjectManagement/ProjectWarAccIssueView.jsx"),
);
const WarehouseMaterialIssueList = lazy(
  () =>
    import("../src/screens/WarehouseManagement/WarehouseMaterialIssueList.jsx"),
);
const WarehouseMaterialIssueView = lazy(
  () => import("../src/screens/WarehouseManagement/WarehouseMAtIssueView.jsx"),
);
const WarehouseMaterialAppIssueView = lazy(
  () => import("./screens/WarehouseManagement/WarehouseMatAccIssueView.jsx"),
);
const WarehouseReqIssueView = lazy(
  () => import("../src/screens/WarehouseManagement/WarehouseReqIssueView.jsx"),
);
const WarehouseAccIssueView = lazy(
  () => import("../src/screens/WarehouseManagement/WarehouseAccIssueView.jsx"),
);

const ProjectReqIssueView = lazy(
  () => import("../src/screens/ProjectManagement/ProjectReqIssueView.jsx"),
);
// Received Material List
const MaterialReceivedList = lazy(
  () => import("./screens/WarehouseManagement/MaterialReceivedList.jsx"),
);
const ReceivedProjReqView = lazy(
  () => import("./screens/WarehouseManagement/ReceivedProjReqView.jsx"),
);
const ReceivedProjAccView = lazy(
  () => import("./screens/WarehouseManagement/RecievedProjAccView.jsx"),
);
const ReceivedWarReqView = lazy(
  () => import("./screens/WarehouseManagement/ReceivedWarReqView.jsx"),
);
const ReceivedWarAccView = lazy(
  () => import("./screens/WarehouseManagement/ReceivedWarAccView.jsx"),
);
// Project Received Material List
const ProjectMaterialReceivedList = lazy(
  () => import("./screens/ProjectManagement/MaterialReceivedList.jsx"),
);
const ProjectReceivedProjReqView = lazy(
  () => import("./screens/ProjectManagement/ReceivedProjReqView.jsx"),
);
const ProjectReceivedProjAccView = lazy(
  () => import("./screens/ProjectManagement/ReceivedProjAccView.jsx"),
);
const ProjectReceivedWarReqView = lazy(
  () => import("./screens/ProjectManagement/ReceivedWarReqView.jsx"),
);
const ProjectReceivedWarAccView = lazy(
  () => import("./screens/ProjectManagement/ReceivedWarAccView.jsx"),
);
const Transaction = lazy(() => import("./screens/Transaction/Transaction.jsx"));
const MaterialReceivedCreate = lazy(() => import("./screens/WarehouseManagement/MaterialReceivedCreate.jsx"));
const MaterialWarProjAdd = lazy(() => import("./screens/Material/MaterialWarProAdd.jsx"));

export default function ReactRoutes() {
  const token = localStorage.getItem("token");

  if (token) {
    HttpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/forget-password/:token" element={<ResetPassword />} />
        <Route element={<PrivateRouter />}>
          <Route element={<Layout />}>
            <Route path="/admin-list" element={<AdminList />} />
            <Route path="/add-admin" element={<AddAdmin />} />
            <Route path="/role-list" element={<Role />} />
            <Route path="/add-role" element={<AddRole />} />
            <Route path="/category-list" element={<CategoryList />} />
            <Route path="/add-category" element={<CategoryAdd />} />
            <Route path="/attributes-list" element={<AttributesList />} />
            <Route path="/add-attributes" element={<AttributesAdd />} />
            <Route
              path="/add-attributes/:attribute_id"
              element={<AttributesAdd />}
            />
            <Route path="/location" element={<Location />} />
            <Route path="/add-location" element={<AddLocation />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/material-list" element={<MaterialList />} />
            <Route path="/add-material" element={<AddMaterial />} />
            <Route path="/material-proj-war-add" element={<MaterialWarProjAdd />} />
            <Route path="/warehouse-list" element={<WarehouseList />} />
            <Route path="/add-warehouse" element={<AddWarehouse />} />
            <Route path="/project-list" element={<ProjectList />} />
            <Route path="/add-project" element={<AddProject />} />
            <Route path="/notification" element={<Notification />} />
            <Route
              path="/warehouse-material-list"
              element={<WareHouseMaterialList />}
            />
            <Route
              path="/warehouse-material"
              element={<WareHouseMaterialAdd />}
            />
            <Route
              path="/project-material-list"
              element={<ProjectMaterialList />}
            />
            <Route path="/project-material" element={<ProjectMaterialAdd />} />
            <Route
              path="/warehouse-material-view-projects"
              element={<WareHouseViewProjects />}
            />
            <Route
              path="/warehouse-reserved-material"
              element={<WareHouseReservedMaterial />}
            />
            <Route
              path="/project-reserved-material"
              element={<ReservedMaterialList />}
            />

            <Route
              path="/project-req-issue-view"
              element={<ProjectReqIssueView />}
            />
            <Route
              path="/project-req-issue-view/:warehouse_id"
              element={<ProjectReqIssueView />}
            />
            <Route
              path="/project-reserved-mat-add"
              element={<ReservedMaterialAdd />}
            />
            <Route
              path="/reserved-mat-issue-list"
              element={<ReservedMaterialIssueList />}
            />
            <Route
              path="/reserved-mat-issue-view"
              element={<ReservedMaterialIssueView />}
            />
            <Route
              path="/project-acc-issue-view"
              element={<ProjectAccIssueView />}
            />
            <Route
              path="/project-war-req-issue-view"
              element={<ProjectWarReqIssueView />}
            />
            <Route
              path="/project-war-acc-issue-view"
              element={<ProjectWarAccIssueView />}
            />
            <Route
              path="/warehouse-mat-issue-list"
              element={<WarehouseMaterialIssueList />}
            />
            <Route
              path="/warehouse-mat-issue-view"
              element={<WarehouseMaterialIssueView />}
            />
            <Route
              path="/warehouse-mat-issue-view/:warehouse_id"
              element={<WarehouseMaterialIssueView />}
            />
            <Route
              path="/warehouse-mat-app-issue-view"
              element={<WarehouseMaterialAppIssueView />}
            />
            <Route
              path="/warehouse-req-issue-view"
              element={<WarehouseReqIssueView />}
            />
            <Route
              path="/warehouse-req-issue-view/:warehouse_id"
              element={<WarehouseReqIssueView />}
            />
            <Route
              path="/warehouse-acc-issue-view"
              element={<WarehouseAccIssueView />}
            />
            <Route
              path="/material-received-list"
              element={<MaterialReceivedList />}
            />
            <Route
              path="/received-proj-req-view"
              element={<ReceivedProjReqView />}
            />
            <Route
              path="/received-proj-app-view"
              element={<ReceivedProjAccView />}
            />
            <Route
              path="/received-war-req-view"
              element={<ReceivedWarReqView />}
            />
            <Route
              path="/received-war-app-view"
              element={<ReceivedWarAccView />}
            />
            <Route
              path="/project-material-received-list"
              element={<ProjectMaterialReceivedList />}
            />
            <Route
              path="/project-received-proj-req-view"
              element={<ProjectReceivedProjReqView />}
            />
            <Route
              path="/project-received-proj-app-view"
              element={<ProjectReceivedProjAccView />}
            />
            <Route
              path="/project-received-war-req-view"
              element={<ProjectReceivedWarReqView />}
            />
            <Route
              path="/project-received-war-app-view"
              element={<ProjectReceivedWarAccView />}
            />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/material-received-create" element={<MaterialReceivedCreate />} />
            <Route path="/material-received-create/:warehouse_id" element={<MaterialReceivedCreate />} />
          </Route>
        </Route>

        {/* future routes */}
        {/*
        <Route path="/registration" element={<Registration />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        */}
      </Routes>
    </Suspense>
  );
}
